import { QuiSizeEnum } from "../tokens/index.js";
export * from "./isEqual.js";
export function parseQuiBaseProps(props) {
    const p = {};
    if (props.className)
        p.className = props.className;
    if (props.style)
        p.style = props.style;
    if (props["data-test"])
        p["data-test"] = props["data-test"];
    return p;
}
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
export function noop() {
    return;
}
export function uniqueId(prefix = "") {
    return `${prefix}-${Math.random().toString(36).substring(2, 9)}`;
}
const QUI_SIZE_VALUES = Object.values(QuiSizeEnum);
export function isQuiSize(v) {
    return QUI_SIZE_VALUES.includes(v);
}
export function getMarginClassesFromQuiMarginToken(marginProp) {
    if (typeof marginProp !== "string")
        return [];
    const m = marginProp.split(" ").filter((s) => isQuiSize(s) || s === "auto");
    if (m.length === 1) {
        return [`qui-margin-top-${m[0]}`, `qui-margin-right-${m[0]}`, `qui-margin-bottom-${m[0]}`, `qui-margin-left-${m[0]}`];
    }
    else if (m.length === 2) {
        return [`qui-margin-top-${m[0]}`, `qui-margin-right-${m[1]}`, `qui-margin-bottom-${m[0]}`, `qui-margin-left-${m[1]}`];
    }
    else if (m.length === 4) {
        return [`qui-margin-top-${m[0]}`, `qui-margin-right-${m[1]}`, `qui-margin-bottom-${m[2]}`, `qui-margin-left-${m[3]}`];
    }
    return [];
}
export function getPaddingClassesFromQuiPaddingToken(paddingProp) {
    if (typeof paddingProp !== "string")
        return [];
    const padding = paddingProp.split(" ");
    if (padding.length === 1) {
        return [`qui-padding-${padding[0]}`];
    }
    else if (padding.length === 2) {
        return [`qui-padding-${padding[0]}-${padding[1]}`];
    }
    else if (padding.length === 4) {
        return [
            `qui-padding-top-${padding[0]}`,
            `qui-padding-right-${padding[1]}`,
            `qui-padding-bottom-${padding[2]}`,
            `qui-padding-left-${padding[3]}`,
        ];
    }
    return [];
}
